import React, {useEffect, useState} from "react";
import {Spinner} from "react-bootstrap";
import BarChart from "../../BarChart/BarChart";
import {
    SITE_ENTITY_LABEL, VARIANT_SITES, WATER_SYSTEM_ENTITY_LABEL
} from "../../../Constants/constants";
import {apolloClientReports} from "../../../GraphQL/config";
import {QUERY_GET_LEAK_VOLUME_OVER_TIME} from "../../../GraphQL/ReportGenerator/queries";
import {
    buildOverTimeCategoriesData, getEndDate, getResolutionName
} from "../Utils/utils";
import convert, {DEFAULT_VOLUME_UNIT} from "../MeasurementText/MeasurementTextConverter";

export default function LeakVolumeOverTimeHighResolution(props) {
    const [chartData, setChartData] = useState();
    const [categories, setCategories] = useState();
    const [volumeUnit, setVolumeUnit] = useState(DEFAULT_VOLUME_UNIT);

    const getLeakVolumeOverTimeFromDB = async () => {
        await apolloClientReports.query({
            query: QUERY_GET_LEAK_VOLUME_OVER_TIME, variables: {
                resolution: getResolutionName(props?.modalResulotion - 1),
                from: props?.selectedDate?.toISOString().split('T')[0],
                to: getEndDate(props?.selectedDate, props?.modalResulotion - 1).toISOString().split('T')[0],
                entityType: props.variant === VARIANT_SITES ? SITE_ENTITY_LABEL : WATER_SYSTEM_ENTITY_LABEL
            }
        }).then(res => {
            let response = res?.data?.leakVolumeEntityHistogram;
            if (!response) {
                console.error(`Data from getLeakVolumeOverTimeFromDB is empty`);
            } else {
                setVolumeUnit(convert(response.measureUnit.volumeUnit));
                let selectedEntitiesIds = props?.selectedEntities?.map((entity) => entity.id);
                let usedEntities = response?.entities?.map((entity) => {
                    if (selectedEntitiesIds.includes(entity.id)) {
                        return entity
                    }
                }).filter((entity) => entity !== undefined);

                setChartData(usedEntities?.map((a, index) => {
                    return {
                        name: a.name, data: a.data?.map((dat) => dat.volume), color: props?.colors[index]
                    }
                }));

                setCategories(buildOverTimeCategoriesData(usedEntities, props.modalResulotion - 1));
            }
        })
    }

    useEffect(async () => {
        if (props.modalResulotion && props.selectedDate) await getLeakVolumeOverTimeFromDB();
    }, [props]);


    return (<>
        {!chartData && <Spinner animation="border" variant="primary"/>}
        {chartData && <BarChart
            volumeUnit={volumeUnit}
            categories={categories}
            data={chartData}
        />}
    </>)
}
